import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';
import EricBetaBadge from './EricBetaBadge.jsx';

function EricHeaderSearch(props) {
  var intl = useIntl();
  var history = props.history;
  var state = useState('');
  var valor = state[0];
  var setValor = state[1];

  function submit() {
    var q = valor.trim();
    if (!q) return;
    setValor('');
    props.history.push('/eric/chat?q=' + encodeURIComponent(q));
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') { e.preventDefault(); submit(); }
  }

  return (
    <li className="nav-item d-none d-md-flex align-items-center" style={{ padding: '0 8px' }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        border: '1px solid #d5d5d5', borderRadius: '20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
        background: '#fff', padding: '0 10px',
        width: '400px', height: '36px'
      }}>
        <img
          src="/assets/eric-icon.png"
          alt="ERIC"
          style={{ width: 29, height: 29, objectFit: 'contain', flexShrink: 0 }}
        />
        <input
          type="text"
          value={valor}
          onChange={function(e) { setValor(e.target.value); }}
          onKeyDown={handleKeyDown}
          placeholder={intl.formatMessage({ id: 'eric.header_search.placeholder', defaultMessage: 'Preguntale a ERIC sobre tu flota...' })}
          style={{
            flex: 1, border: 'none', outline: 'none', boxShadow: 'none',
            background: 'transparent', fontSize: '14px', color: '#333',
            minWidth: 0
          }}
        />
        <EricBetaBadge />
        {valor.trim() ? (
          <button
            type="button"
            onClick={submit}
            style={{
              width: 26, height: 26, borderRadius: '8px', flexShrink: 0,
              background: '#7c3aed', color: '#fff', border: 'none', cursor: 'pointer',
              position: 'relative', padding: 0, fontSize: 13
            }}
          >
            <i className="fa fa-arrow-up" style={{
              position: 'absolute', top: '50%', left: '50%',
              transform: 'translate(-50%, -50%)', lineHeight: 1
            }}></i>
          </button>
        ) : null}
      </div>
    </li>
  );
}

export default withRouter(EricHeaderSearch);
